export default __webpack_public_path__ + "static/media/delete.a32f85cf.svg";